module.exports = __webpack_public_path__ + "images/avatars/female/7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/7.png
// module id = hflI
// module chunks = 118